export const CONTRACT_ADDRESS = {
    BREAKER: process.env.REACT_APP_BREAKER_CONTRACT_ADR,
    MAKER: process.env.REACT_APP_MAKER_CONTRACT_ADR,
}